export class HttpNoNetworkConnectionError extends Error {
  public wasCaught = true;

  constructor() {
    super('No network connection');
  }
}
